import { trpc } from '@/utils/trpc'

export const useGetTeamMembers = (canRun: boolean = true) => {
  const { data: teamMembers, isLoading: isLoadingTeamMembers } = trpc.getTeamMembers.useQuery(undefined, {
    enabled: canRun,
  })
  return { teamMembers, isLoadingTeamMembers }
}
